import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenancyContext } from '@core/tenancy';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { MinortStartRoutesSegments } from '@app/minor-estates/features/start/shared/enums';
import { MinorRouteSegmentsEnum } from '@app/minor-estates/shared/enums';
import { MinorPreviewRoutesSegments } from '../../enums/preview-route-segments.enum';

@Injectable({
  providedIn: 'root',
})
export class MinorPreviewNavigationService {
  private readonly _router = inject(Router);
  private readonly _tenancy = inject(TenancyContext);

  public goToRelationshipConfirmation() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.MINOR,
        MinorRouteSegmentsEnum.Start,
        MinortStartRoutesSegments.Preview,
        MinorPreviewRoutesSegments.RelationshipConfirmation,
      ),
    ]);
  }
  public goToMinorInformation() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.MINOR,
        MinorRouteSegmentsEnum.Start,
        MinortStartRoutesSegments.Preview,
        MinorPreviewRoutesSegments.MinorInformation,
      ),
    ]);
  }
}
